"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DeleteModal;
var react_1 = __importDefault(require("react"));
// @ts-ignore
var button_1 = __importStar(require("stories/button"));
// @ts-ignore
var action_modal_1 = __importDefault(require("../action.modal"));
// @ts-ignore
var text_1 = __importDefault(require("../text"));
function DeleteModal(_a) {
    var isOpen = _a.isOpen, objectName = _a.objectName, onSubmitDelete = _a.onSubmitDelete, onCancel = _a.onCancel, _b = _a.warning, warning = _b === void 0 ? '' : _b;
    return (react_1.default.createElement(action_modal_1.default, { isOpen: isOpen, title: "Delete ".concat(objectName), onCancel: function () { return onCancel(); }, buttons: [
            react_1.default.createElement(button_1.default, { "data-qa-confirm-delete": true, key: "delete", type: button_1.ButtonType.permanent, onClick: function () { return onSubmitDelete(); } }, "Delete"),
        ] },
        react_1.default.createElement(text_1.default, { align: "center" },
            "Are you sure you want to delete this ",
            objectName.toLowerCase(),
            "? This action cannot be undone."),
        !!warning && (react_1.default.createElement(text_1.default, { align: "center", mt: 10 }, warning))));
}
